import trackingHomeNeighborhood from './trackingHomeNeighborhood';

const trackingMiddleWare = (store) => (next) => (action) => {
    trackingHomeNeighborhood(store, action);
    return next(action);
};

export default trackingMiddleWare;
